/**
 * Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import { CLEAN_FILTER_CONFIG, getFilterConfigForProduct } from '../../../../common/metadata/FilterConfig';

export const getFilters = (groupKey, subGroupKey, productConfig = null, productKey = null) => {
    // Use the product-specific catalog when a product is known, so groups/filters
    // outside the product never surface (even if a stale override references them).
    const catalog = productKey ? getFilterConfigForProduct(productKey) : CLEAN_FILTER_CONFIG;
    const groupObj = catalog.groups?.find(g => g.key === groupKey);
    const subGroupObj = groupObj?.subgroups?.find(s => s.key === subGroupKey);
    const rawOptions = subGroupObj?.filters || [];

    if (!productConfig || rawOptions.length === 0) return rawOptions;

    const displayModeMap = {};
    if (productConfig.filters) {
        productConfig.filters.forEach(f => {
            displayModeMap[f.FILTER_ID] = f.DISPLAY_MODE;
        });
    }

    let processed = rawOptions.map(opt => {
        const currentKey = `${groupKey}_${subGroupKey}_${opt.id}`;
        // A per-org override always wins; absent one, fall back to the
        // filter's own default (e.g. COMPANY_ID/CONTACT_ID/BUILDER_ID default
        // to Hidden), and absent that, Visible.
        const mode = displayModeMap[currentKey] ?? opt.defaultDisplayMode ?? 'Visible';

        return {
            ...opt,
            isHidden: mode === 'Hidden',
            isLocked: mode === 'Locked'
        };
    }).filter(opt => !opt.isHidden);

    // const restrictions = productConfig.restrictions;
    // if (restrictions) {
    //     // Example for Trade
    //     if (groupKey === 'TRADES' && restrictions.tradeClassifications?.length > 0) {
    //         processed = processed.filter(opt =>
    //             restrictions.tradeClassifications.includes(opt.label) ||
    //             restrictions.tradeClassifications.includes(opt.value)
    //         );
    //     }
    //     // Example for Region (State)
    //     if (groupKey === 'TERRITORY' && subGroupKey === 'STATE' && restrictions.regions?.length > 0) {
    //         processed = processed.filter(opt => restrictions.regions.includes(opt.value));
    //     }
    // }

    return processed;
};